import { render, staticRenderFns } from "./SelectWrapper.vue?vue&type=template&id=3dae2715"
import script from "./SelectWrapper.vue?vue&type=script&lang=js"
export * from "./SelectWrapper.vue?vue&type=script&lang=js"
import style0 from "./SelectWrapper.vue?vue&type=style&index=0&id=3dae2715&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports